import http from "../axios/http-common";

class InterfacePenunjang {
  getGroupLayananLab() {
    return http.getData(`/referensi/group-item-layanan-lab`);
  }
  getGroupLayananRadiologi() {
    return http.getData(`/referensi/group-item-layanan-radiologi`);
  }
  getOrderLabById(id) {
    return http.getData(`/order-lab/${id}`);
  }
  getOrderRadiologiById(id) {
    return http.getData(`/order-ro/${id}`);
  }
  saveOrderLab(
    register_id,
    date,
    unit_id,
    pasien_rm,
    clinical_note,
    other_note,
    dokter_id,
    items,
    prioritas
  ) {
    return http.postData(`/order-lab`, {
      register_id: register_id,
      date: date,
      unit_id: unit_id,
      pasien_rm: pasien_rm,
      clinical_note: clinical_note,
      other_note: other_note,
      dokter_id: dokter_id,
      items: items,
      prioritas: prioritas
    });
  }
  editOrderLab(
    id,
    register_id,
    date,
    unit_id,
    pasien_rm,
    clinical_note,
    other_note,
    dokter_id,
    items,
    prioritas
  ) {
    return http.putData(`/order-lab/${id}`, {
      register_id: register_id,
      date: date,
      unit_id: unit_id,
      pasien_rm: pasien_rm,
      clinical_note: clinical_note,
      other_note: other_note,
      dokter_id: dokter_id,
      items: items,
      prioritas: prioritas
    });
  }
  saveOrderRadiologi(
    register_id,
    date,
    unit_id,
    pasien_rm,
    clinical_note,
    other_note,
    dokter_id,
    items
  ) {
    return http.postData(`/order-ro`, {
      register_id: register_id,
      date: date,
      unit_id: unit_id,
      pasien_rm: pasien_rm,
      clinical_note: clinical_note,
      other_note: other_note,
      dokter_id: dokter_id,
      items: items
    });
  }
  editOrderRadiologi(
    id,
    register_id,
    date,
    unit_id,
    pasien_rm,
    clinical_note,
    other_note,
    dokter_id,
    items
  ) {
    return http.putData(`/order-ro/${id}`, {
      register_id: register_id,
      date: date,
      unit_id: unit_id,
      pasien_rm: pasien_rm,
      clinical_note: clinical_note,
      other_note: other_note,
      dokter_id: dokter_id,
      items: items
    });
  }

  getOrderLabByReg(reg) {
    return http.getData(`/register/${reg}/order-lab`);
  }

  getOrderRadiologiByReg(reg) {
    return http.getData(`/register/${reg}/order-ro`);
  }

  cancelOrderLab(id, alasan) {
    return http.putData(`/order-lab/${id}/cancel`, {
      alasan_batal: alasan
    });
  }

  cancelOrderRadiologi(id, alasan) {
    return http.putData(`/order-ro/${id}/cancel`, {
      alasan_batal: alasan
    });
  }
  saveTemplate(nama, category, items) {
    return http.postData(`/template/order-penunjang`, {
      nama: nama,
      category: category,
      items: items
    });
  }
  getTemplate(type) {
    return http.getData(`/template/order-penunjang/${type}`);
  }
  deleteTemplate(id) {
    return http.deleteData(`/template/order-penunjang/${id}`);
  }
  getListHasilRo(reg) {
    // utk list di page kunjungan
    return http.getData(`/list-ro/${reg}`);
  }
  getListHasilRoByRm(rm) {
    return http.getData(`/pasien/${rm}/list-radiologi`);
  }
  getDetailHasilRo(no_trans, tgl, kode) {
    return http.getData(`/hasil-ro/${no_trans}/${tgl}/${kode}`);
  }
  getListHasilLab(reg) {
    // utk list di page kunjungan
    return http.getData(`/list-lab/${reg}`);
  }

  getAssesmenPenunjang(unit, reg) {
    return http.getDataParam(`/register/${reg}/pemeriksaan-penunjang`, {
      params: {
        unit_id: unit
      }
    });
    //  return http.getData(`/unit/${unit}/register/${reg}/pemeriksaan-penunjang`);
  }

  getAssesmenPenunjangByRm(rm) {
    return http.getData(`/rm/${rm}/pemeriksaan-penunjang`);
  }
  getAssesmenPenunjangByID(id) {
    return http.getData(`/pemeriksaan-penunjang/${id}`);
  }
  saveAssesmenPenunjang(
    reg,
    rm,
    unit_id,
    // user_id,
    catatan
  ) {
    return http.postData(`/pemeriksaan-penunjang`, {
      register_id: reg,
      pasien_rm: rm,
      unit_id: unit_id,
      // user_id: user_id,
      pemeriksaan: catatan
    });
  }

  editAssesmenPenunjang(
    id,
    reg,
    rm,
    unit_id,
    // user_id,
    catatan
  ) {
    return http.putData(`/pemeriksaan-penunjang/${id}`, {
      register_id: reg,
      pasien_rm: rm,
      unit_id: unit_id,
      // user_id: user_id,
      pemeriksaan: catatan
    });
  }
  getListHasilLabByRm(rm, tgl_masuk, tgl_keluar) {
    // return http.getData(`/hasil-lab/${rm}/${tgl_masuk}/${tgl_keluar}`);
    return http.getDataParam(`/hasil-lab-baru/${rm}`, {
      params: {
        tgl_masuk: tgl_masuk,
        tgl_keluar: tgl_keluar
      }
    });
  }

  // Riwayat hasil lab lintas-kunjungan (RM.LAB.RIWAYAT.01) — sudah ter-enrich
  // unit klinis + jenis kunjungan, filter tanggal opsional via query.
  getRiwayatLab(rm, tgl_masuk = "", tgl_keluar = "") {
    return http.getDataParam(`/riwayat-lab/${rm}`, {
      params: {
        tgl_masuk: tgl_masuk,
        tgl_keluar: tgl_keluar
      }
    });
  }

  getKategoriPenunjangLain() {
    return http.getData(`/combo/penunjang-lain-kategori`);
  }

  getKbMetode() {
    return http.getData(`/combo/kb-metode`);
  }

  getPenunjangLain(reg) {
    return http.getData(`/register/${reg}/penunjang-lain`);
  }

  getPenunjangLainByRm(rm) {
    return http.getData(`/penunjang-lain/${rm}`);
  }
  savePenunjangLain(
    // penunjang_lain_kategori_id,
    // register_id,
    // tanggal,
    // waktu_periksa,
    // unit_id,
    // pasien_rm,
    // catatan,
    // file
    param
  ) {
    return http.postData(`/penunjang-lain/upload`, {
      penunjang_lain_kategori_id: param["penunjang_lain_kategori_id"],
      register_id: param["register_id"],
      tanggal: param["tanggal"],
      waktu_periksa: param["waktu_periksa"],
      unit_id: param["unit_id"],
      pasien_rm: param["pasien_rm"],
      catatan: param["catatan"],
      file: param["file[]"]
    });
  }
}

export default new InterfacePenunjang();
